module.exports = {
      id: "Ee-logo-usage",
      viewBox: "0 0 38 37",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/product/sprite.svg#Ee-logo-usage",
      toString: function () {
        return this.url;
      }
    }